document.addEventListener("DOMContentLoaded", function () {
  let marqueeSliders = document.querySelectorAll(".floating-text-container");

  marqueeSliders.forEach((marqueeSlider) => {
    let mainTicker = new Flickity(marqueeSlider, {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
    });

    mainTicker.x = 0;
    let requestId;

    function play() {
      mainTicker.x -= 1.2;
      mainTicker.settle(mainTicker.x);
      requestId = window.requestAnimationFrame(play);
    }

    function pause() {
      if (requestId) {
        window.cancelAnimationFrame(requestId);
        requestId = undefined;
      }
    }

    marqueeSlider.addEventListener("mouseenter", () => pause());
    marqueeSlider.addEventListener("mouseleave", () => play());

    play();
  });
});